<template>
    <v-dialog v-model="model" width="900">
        <v-card height="800" class="iframeWrapper">
            <iframe :srcdoc="html" />
            <v-card-actions class="justify-center">
                <v-btn @click="model = false">{{ $t('close') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class EmailPreviewModal extends Vue {
        @VModel() model
        @Prop({required: true}) html
    }

    export default EmailPreviewModal
</script>

<style scoped lang="scss">
    .iframeWrapper {
        line-height: 0;
    }

    iframe {
        border: none;
        width: 100%;
        height: 100%;
    }
</style>
